"use client";

import { Link } from "~/i18n/navigation";
import { ArrowRight } from "lucide-react";
import { useTranslations } from "next-intl";

const PreFooterCTA = () => {
  const t = useTranslations("Footer");

  return (
    <div className="from-pory-blue-900 to-pory-blue-950 bg-gradient-to-r">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-between gap-4 px-6 py-6 sm:flex-row">
        <div className="flex items-center gap-3">
          <p className="text-sm font-semibold text-white">
            {t("ctaHeading")}{" "}
            <span className="text-pory-blue-300 font-normal">
              {t("ctaSupporter")}
            </span>
          </p>
        </div>
        <Link
          id="prefooter-cta-signup"
          href="/sign-up"
          className="hover:bg-pory-pink-500 inline-flex shrink-0 items-center gap-1.5 rounded-full bg-pory-pink-400 px-5 py-2 text-sm font-bold text-white transition-colors duration-200"
        >
          {t("ctaButton")}
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
};

export default PreFooterCTA;
